import { FC, useState } from "react";

export interface SectionHeroProps {
  className?: string;
  aboutUs: any;
}

const SectionAbout: FC<SectionHeroProps> = ({ className = "", aboutUs }) => {
  const { image_url, heading, description, width, height, alignment } = aboutUs;
  const [expanded, setExpanded] = useState(false);
  const isTruncated = description.length > 500;
  const shortDescription =
    description?.length > 500 ? description?.slice(0, 500) : description;
  const [imgLoaded, setImgLoaded] = useState(true);

  return (
    <div
      className={`nc-SectionHero relative ${className} rounded-md lg:pr-4`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 items-center relative text-center lg:text-left lg:justify-between">
        {image_url && (
          <div className="flex-grow">
            <img
              className={`object-cover rounded-2xl ${
                alignment === "right"
                  ? "ml-auto"
                  : alignment === "left"
                  ? "mr-auto"
                  : "mx-auto"
              }`}
              src={image_url}
              alt=""
              style={{ width: `${width}px`, height: `${height}px` }}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
                setImgLoaded(false);
              }}
            />
          </div>
        )}
        <div
          className={
            "w-full max-w-full text-center" +
            (image_url ? " lg:text-left w-1/2 " : "") +
            (imgLoaded ? " mx-10 " : "")
          }
        >
        <h2 className="mb-4 font-semibold leading-none text-text-color text-3xl md:text-5xl"
          dangerouslySetInnerHTML={{ __html: (heading) }}
        />
          <span className="block !font-normal leading-none !text-lg text-secondary-text-color break-words text-wrap">
            {expanded || !isTruncated ? (
              <span dangerouslySetInnerHTML={{ __html: description }} />
            ) : (
              <>
                <span dangerouslySetInnerHTML={{ __html: shortDescription }} />
                ...
              </>
            )}
            {isTruncated && (
              <button
                type="button"
                className="ml-2 text-primary font-semibold focus:outline-none inline cursor-pointer"
                onClick={() => setExpanded((v) => !v)}
                style={{ display: "inline" }}
              >
                {expanded ? "View less" : "View more"}
              </button>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionAbout;
